import { SVGProps } from 'react'

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" fill="none" viewBox="0 0 4 8" {...props}>
    <path fill="currentColor" d="M4 0L0 4l4 4V0z"></path>
  </svg>
)
